export const FETCH_HOSPITAL_FAIL = "FETCH_HOSPITAL_FAIL";
export const FETCH_HOSPITAL_SUCCESS = "FETCH_HOSPITAL_SUCCESS";
export const FETCH_HOSPITAL_REQUEST = "FETCH_HOSPITAL_REQUEST";

export const CREATE_HOSPITAL_FAIL = "CREATE_HOSPITAL_FAIL";
export const CREATE_HOSPITAL_SUCCESS = "CREATE_HOSPITAL_SUCCESS";
export const CREATE_HOSPITAL_REQUEST = "CREATE_HOSPITAL_REQUEST";

export const UPDATE_HOSPITAL_FAIL = "UPDATE_HOSPITAL_FAIL";
export const UPDATE_HOSPITAL_SUCCESS = "UPDATE_HOSPITAL_SUCCESS";
export const UPDATE_HOSPITAL_REQUEST = "UPDATE_HOSPITAL_REQUEST";

export const SHOW_HOSPITAL_FAIL = "SHOW_HOSPITAL_FAIL";
export const SHOW_HOSPITAL_SUCCESS = "SHOW_HOSPITAL_SUCCESS";
export const SHOW_HOSPITAL_REQUEST = "SHOW_HOSPITAL_REQUEST";